// A lost finish receipt can already have committed the session server-side.
// Keep the original connection/input frozen until an identical retry resolves it.
export const isArchiveError = (error) => [
  "archive_failed", "archive_transcription_pending", "archive_pending",
].includes(error?.type);

export const ARCHIVE_RETRY_MESSAGE = "归档尚未确认，已暂停输入和中断。请保持连接并点击“重试归档”。";
export const ARCHIVE_DISCONNECTED_MESSAGE = "连接已断开，归档结果尚未确认。请核对课程归档状态，勿将本次会话视为未归档。";
